import logo from "../../assets/images/logo-red.png";
export default function PageHeader({
  title,
  subtitle,
  tag,
  actions,
  hasLogo,
}: any) {
  return (
    <div className="border-b px-4 py-3 flex justify-between items-center h-18">
      <div className="flex justify-center items-center">
        {hasLogo ? (
          <div className="mr-2 border-r pr-2">
            <img src={logo} alt="Logo" height={20} width={50} />
          </div>
        ) : null}
        <div className="flex flex-col justify-between">
          <div className="text-lg font-bold flex">
            <div className="">{title} : </div>
            <div className="font-normal ml-1">{tag}</div>
          </div>
          <div className="text-gray-600">{subtitle}</div>
        </div>
      </div>
      <div className="">{actions}</div>
    </div>
  );
}
